import React from 'react';

export default ({ ...style }) => <div {...style} />;
